import React, { Component } from 'react';
import { Button, Form, Modal, Select } from 'antd';

import UploadFile from '@comm/upload/UploadFile';
import { queryDownloadGroupSetTemplate } from '@api/finance/budget';

const FormItem = Form.Item;
const { Option } = Select;

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
    };
  }

  componentWillMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }

    const income = this.props.form.getFieldsValue();

    const obj = Object.assign(this.state.content, income);
    if (this.state.licenseFile && this.state.licenseFile.length > 0) {
      obj.fileUuid = this.state.licenseFile[0].uuid;
    }
    const { handleSubmit } = this.props;
    this.props.form.validateFields(err => {
      if (!err) {
        handleSubmit(obj);
      }
    });
  };

  handlelicenseFile = fileList => {
    this.setState({
      licenseFile: fileList,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const licenseFile = this.state.licenseFile || [];
    const date = new Date();
    const year = date.getFullYear();
    const years = [];
    for (let i = year + 1; i >= 2014; i--) {
      years.push(i.toString());
    }
    return (
      <Modal
        title="导入"
        visible
        onCancel={this.props.cancel}
        onOk={this.submit}
        footer={[
          <Button key="back" onClick={this.props.cancel}>
            取消
          </Button>,
          <Button key="submit" type="primary" loading={this.props.loading} onClick={this.submit}>
            确定
          </Button>,
        ]}
      >
        <Form layout="horizontal">
          <FormItem label="请选择年份" {...formItemLayout}>
            {getFieldDecorator('year', {
              rules: [{ required: true, message: '请选择年份' }],
            })(
              <Select>
                {years.map(item => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem label="上传Excel文件" {...formItemLayout} required>
            <UploadFile
              type="ghost"
              handleUpload={this.handlelicenseFile}
              fileList={licenseFile}
              isExcel
            />
            <span className="ant-form-text">
              &nbsp;仅限excel格式
              <a onClick={() => queryDownloadGroupSetTemplate()} style={{ marginLeft: '10px' }}>
                模板下载
              </a>
            </span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(DetailModal);



// WEBPACK FOOTER //
// ./src/components/finance/budget/ModalImport.js